const authGuard = (meta) => meta.dispatch(authGuardAction(meta));

const authGuardAction = (to) => (_dispatch, getState) => {

	const state = getState()

	const checkPath = [
		"/login",
		"/installation",
		"/software-update",
	];

	const currentPath = to?.location?.currentPath;

	if (!state.auth.loggedIn && !(checkPath.includes(currentPath)) ) {
		if (currentPath && currentPath !== '/') {
			const search = typeof window !== 'undefined' ? window.location.search : '';
			return `/login?returnUrl=${encodeURIComponent(currentPath + (search || ''))}`;
		}
		return '/login'
	}

	return null
}

export { authGuard };
